import React from 'react'
import PropTypes from 'prop-types'
import { Configure } from 'react-instantsearch-dom'
import { isNil } from 'ramda'
import defaults from '@config/defaults'

const metersPerMile = 1609
const twoHundredMilesInMeters = 200 * metersPerMile
const currentTime = new Date().getTime() / 1000

const composeTagsFilter = (tags) => {
  let tagFilters = ''
  if (tags) {
    tags.forEach((tag, index) => {
      if (index === 0) {
        tagFilters = ` AND (tags:'${tag}'`
      } else {
        tagFilters = `${tagFilters} OR tags:'${tag}'`
      }
    })
    tagFilters = `${tagFilters})`
  }
  return tagFilters
}

export const ConfigureWithLatLng = ({ aroundLatLng, aroundRadius, searchState }) => {
  const tags = searchState?.refinementList?.tags
  const tagFilters = composeTagsFilter(tags)
  return (
    <Configure
      aroundLatLng={aroundLatLng}
      aroundRadius={aroundRadius || twoHundredMilesInMeters}
      hitsPerPage={defaults.groupEventsPerPage}
      maxValuesPerFacet={50}
      facets={['_geoloc', 'tags']}
      filters={`(registration_closed:false OR registration_closed:null) AND start_date_time_ts > ${currentTime} AND registration_close_date_time_ts > ${currentTime} AND start_date_time_ts > ${currentTime} ${tagFilters} AND is_canceled:false`}
    />
  )
}

ConfigureWithLatLng.propTypes = {
  aroundLatLng: PropTypes.string,
  aroundRadius: PropTypes.number,
  searchState: PropTypes.object,
}

export const ConfigureWithoutLatLng = ({ searchState, aroundRadius }) => {
  const tags = searchState?.refinementList?.tags
  const resetAll = searchState?.reset === 'all'
  const tagFilters = composeTagsFilter(tags)

  return resetAll ? (
    <Configure
      hitsPerPage={defaults.groupEventsPerPage}
      maxValuesPerFacet={50}
      facets={['_geoloc', 'tags']}
      filters={`(registration_closed:false OR registration_closed:null) AND start_date_time_ts > ${currentTime} AND registration_close_date_time_ts > ${currentTime} ${tagFilters} AND is_canceled:false`}
    />
  ) : (
    <Configure
      aroundLatLngViaIP
      aroundRadius={aroundRadius || twoHundredMilesInMeters}
      hitsPerPage={defaults.groupEventsPerPage}
      maxValuesPerFacet={50}
      facets={['_geoloc', 'tags']}
      filters={`(registration_closed:false OR registration_closed:null) AND start_date_time_ts > ${currentTime} AND registration_close_date_time_ts > ${currentTime} ${tagFilters} AND is_canceled:false`}
    />
  )
}

ConfigureWithoutLatLng.propTypes = {
  searchState: PropTypes.object,
  aroundRadius: PropTypes.number,
}

const ConfigureWithLocation = ({ aroundLatLng, aroundRadius, searchState }) => (
  isNil(aroundLatLng)
    ? <ConfigureWithoutLatLng {...{ searchState, aroundRadius }} />
    : <ConfigureWithLatLng {...{ aroundLatLng, aroundRadius, searchState }} />
)

ConfigureWithLocation.propTypes = {
  aroundLatLng: PropTypes.string,
  aroundRadius: PropTypes.number,
  searchState: PropTypes.object,
}

export default ConfigureWithLocation
